import { DashboardApi } from '@/shared/api'
import { DashboardData, DashboardStats, DashboardTrip } from '@/shared/api'
import type { TripUpdateItem } from '@/shared/api/dashboard'

// Dashboard service class - simplified to single endpoint
export class DashboardService {
  private dashboardApi: DashboardApi

  constructor(getAuthToken: () => Promise<string | null>) {
    this.dashboardApi = new DashboardApi(getAuthToken)
  }

  // Get complete dashboard data - single optimized call
  async getDashboard(): Promise<DashboardData> {
    return this.dashboardApi.getDashboard()
  }

  async getTripUpdates(limit = 15): Promise<TripUpdateItem[]> {
    return this.dashboardApi.getTripUpdates(limit)
  }

  // Utility methods for data transformation
  formatTripDates(trip: DashboardTrip): DashboardTrip {
    return {
      ...trip,
      start_date: trip.start_date ? new Date(trip.start_date).toISOString().split('T')[0] : null,
      end_date: trip.end_date ? new Date(trip.end_date).toISOString().split('T')[0] : null
    }
  }

  getTripDuration(trip: DashboardTrip): number | null {
    if (!trip.start_date || !trip.end_date) return null
    
    const start = new Date(trip.start_date)
    const end = new Date(trip.end_date)
    const diffTime = Math.abs(end.getTime() - start.getTime())
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24))
    
    return diffDays
  }

  isTripActive(trip: DashboardTrip): boolean {
    if (!trip.start_date || !trip.end_date) return false
    
    const now = new Date()
    const start = new Date(trip.start_date)
    const end = new Date(trip.end_date)
    
    return now >= start && now <= end
  }

  isTripUpcoming(trip: DashboardTrip): boolean {
    if (!trip.start_date) return false
    
    const now = new Date()
    const start = new Date(trip.start_date)
    
    return now < start
  }

  isTripPast(trip: DashboardTrip): boolean {
    if (!trip.end_date) return false
    
    const now = new Date()
    const end = new Date(trip.end_date)
    
    return now > end
  }
}
